export default __webpack_public_path__ + "static/media/call.d4d5adf5.png";